import type { FC, SVGProps } from "react";

/** `locate-fixed` — crosshair GPS glyph, Figma `Component 7/locate-fixed` (node 1:498). The
 *  center dot fills solid on `:active` when rendered inside a `group`-classed button, giving
 *  press feedback on the GPS trigger. */
export const LocateFixedIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.33203 14H5.83203" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22.168 14H25.668" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 2.33325V5.83325" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 22.1667V25.6667" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.9987 22.1666C18.509 22.1666 22.1654 18.5102 22.1654 13.9999C22.1654 9.48959 18.509 5.83325 13.9987 5.83325C9.48837 5.83325 5.83203 9.48959 5.83203 13.9999C5.83203 18.5102 9.48837 22.1666 13.9987 22.1666Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z"
      className="fill-none transition-colors group-active:fill-current"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
